document.addEventListener('DOMContentLoaded', () => {
  const cardImages = {
    'Snowmobile Parts': '[data-lyon-bumper-img]',
    'Outdoor Cooking': '[data-lyon-smoker-img]',
    'Powder Coating & Blasting': '[data-lyon-services-img]'
  };
  document.querySelectorAll('.lyon-offer__card-img[data-offer-title]').forEach(img => {
    const title = img.getAttribute('data-offer-title');
    const selector = cardImages[title];
    if (!selector) return;
    const meta = document.querySelector(selector);
    if (meta) img.src = meta.content;
  });

  const whyUs = document.querySelector('[id$="__why_us"]');
  if (whyUs) {
    const meta = document.querySelector('[data-lyon-team-img]');
    if (!meta) return;
    const url = meta.content;
    const mediaItem = whyUs.querySelector('.image-with-text__media-item');
    if (!mediaItem) return;
    const media = mediaItem.querySelector('.media');
    if (!media) return;

    let img = media.querySelector('img');
    if (img) {
      img.srcset = '';
      img.sizes = '';
      img.src = url;
      img.alt = 'Lyon Built Team';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;object-position:center 20%;position:absolute;inset:0;opacity:1 !important;';
      img.removeAttribute('width');
      img.removeAttribute('height');
      const svg = media.querySelector('svg');
      if (svg) svg.style.display = 'none';
    } else {
      media.style.position = 'relative';
      media.innerHTML = '<img src="' + url + '" style="width:100%;height:100%;object-fit:cover;object-position:center 20%;position:absolute;inset:0;" alt="Lyon Built Team" loading="eager">';
    }
  }
});
